/**
 * 瓦斯行「賣方身分」（名稱＋統一編號）的顯示規則。
 *
 * 為什麼要在下單頁顯示：客戶下單的交易對象是瓦斯行（平台只做代收/媒合），
 * 名稱與統編是判斷「跟誰買」的唯一依據，兩個下單入口（一鍵下單 /kiosk、
 * 訂購頁 /gasShop/products）都要看得到。
 *
 * 資料來源：bootstrap `available_suppliers[]`。後端目前尚未帶 `tax_id_number`
 *（Supplier 實體有此欄，只在瓦斯行後台那支 API 回傳）→ 欄位缺漏時一律隱藏，
 * 不顯示「統編：--」這種半殘資訊。
 */

/** 台灣統編固定 8 碼數字；不合格式視同沒有（後端若回空字串/佔位字元不顯示）。 */
export const isValidTaxId = (taxId?: string | number | null): boolean => /^\d{8}$/.test(String(taxId ?? "").trim());

/** 正規化統編：合格才回傳字串，否則 null。 */
export const normalizeTaxId = (taxId?: string | number | null): string | null => {
  const value = String(taxId ?? "").trim();
  return isValidTaxId(value) ? value : null;
};

/**
 * 正規化聯絡電話：去空白，空值回 null（呼叫端不顯示撥打鍵）。
 * 不做格式驗證——瓦斯行電話有市話/手機/分機多種寫法，過濾反而會擋掉合法號碼。
 */
export const normalizePhone = (phone?: string | null): string | null => {
  const value = String(phone ?? "").trim();
  return value ? value : null;
};

/** `tel:` 連結用：只留數字、+、# 與分機常見的逗號，避免號碼含空白/破折號時撥不出去。 */
export const toTelHref = (phone: string): string => `tel:${phone.replace(/[^\d+#,]/g, "")}`;
